import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../Assets/img/logo_pressing360-black.png'
const Navbar = () => {

    const location = useLocation(); // Récupère l'URL actuelle

    const handleAccueilClick = () => {
        if (location.pathname != "/") {

            window.location.href = "/";
        } else {
            handleScrollToSection("hero");
        }
    };


    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleScrollToSection = (sectionId) => {
        // Effectuer le défilement vers la section
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });

            // Mettre à jour l'URL sans afficher le hachage
            window.history.pushState(null, "", window.location.pathname);
        }
    };
    return (
        <nav
            className={`navbar navbar-expand-lg navbar-light fixed-top ${scrolled ? 'navbar-custom' : 'bg-white shadow'
                }`}
        >
            <div className="container-xl">
                <Link className="navbar-brand" onClick={handleAccueilClick}>
                    <img
                        src={logo}
                        className="h-8 logo_main"
                        alt="..."
                    />
                </Link>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarCollapse"
                    aria-controls="navbarCollapse"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                    <div className="navbar-nav mx-lg-auto">
                        <button
                            className="nav-item nav-link"
                            onClick={handleAccueilClick}
                        >
                            Acceuil
                        </button>
                        <button
                            className="nav-item nav-link"
                            onClick={() => handleScrollToSection("explanatoryvideo")}
                        >
                            Explication
                        </button>
                        <button
                            className="nav-item nav-link"
                            onClick={() => handleScrollToSection("pricing")}
                        >
                            Tarification
                        </button>
                        <button
                            className="nav-item nav-link"
                            onClick={() => {
                                window.location.href = "https://formation.pressing360.com/";
                            }}
                        >
                            Formations
                        </button>

                    </div>

                    <div className="d-flex align-items-lg-center mt-3 mt-lg-0">
                        <Link to={`https://wa.me/2250788898998?text=Bonjour Elk-Tech Groupe, est-ce qu'il serait possible de discuter avec quelqu'un au sujet du logiciel Pressing 360? `} className="btn btn-sm btn-danger w-full w-lg-auto">
                            <i className="fa-brands fa-whatsapp"></i> Parler à un commercial
                        </Link>

                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
